module.exports = __webpack_public_path__ + "img/logo-fifalotto-white5-wisdombet.28a14405.png";